<template>
  <popup :close-action="closeActionClicked" :buttons="buttons" class="referral-test-popup" :title="'לצמוח עם riseup!'">
    <template v-slot:content>
      <div class="referral-content">
        <div class="bold">עוזרים לעוד ישראלים וישראליות לצמוח</div>
        <div>מפיצים את הלינק להרשמה לשירות, ועל כל לקוח ולקוחה שמצטרפים נזכה אותך בחודש אחד חינם!</div>
        <div>אין מגבלה על כמות החברים והחברות שאפשר לצרף.</div>
        <div class="bold">יאללה, בואו נצמח ביחד! 💪</div>
        <web-share ref="webShare" :url="referralLink || ''" :text="shareText" title="לצמוח עם riseup" :alternativeAction="referViaWhatsApp"
          @share-started="shareStarted" @share-done="shareDone" @share-aborted="shareAborted" @share-failed="shareFailed"/>
      </div>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import Segment from '../../../../Segment';
import DDLogs from '../../../../DDLogs';

export default {
  name: 'ReferralPopup',
  components: {
    Popup: BaseUI.Popup,
    WebShare: BaseUI.WebShare,
  },
  data() {
    return {
      loading: false,
      disabled: true,
    };
  },
  async created() {
    Segment.trackUserInteraction('ReferralPopupShown');
    await this.init(this.householdName);
    this.disabled = false;
  },
  computed: {
    ...mapState('session', ['customerId']),
    ...mapGetters('session', ['householdName']),
    ...mapState('referral', ['referralLink']),
    referralMessage() {
      return `${this.shareText} ${this.referralLink}`;
    },
    shareText() {
      return 'הי 👋 רציתי לספר לך על riseup - שירות שעוזר לי ולעוד אלפי ישראלים וישראליות לנצח את החודש ולצמוח כלכלית 💪 חודש ניסיון בחינם:';
    },
    buttons() {
      return [{
        title: 'אני רוצה לשתף',
        action: this.shareLink,
        variant: 'warning',
        disabled: this.disabled,
        loading: this.loading,
        size: 'slim',
      }];
    },
  },
  methods: {
    ...mapActions('referral', ['init']),
    closeActionClicked() {
      Segment.trackUserInteraction('ReferralPopup_CloseButtonClicked');
      this.$emit('close');
    },
    referViaWhatsApp() {
      Segment.trackUserInteraction('ReferralPopup_SendReferralLinkClicked');
      window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(this.referralMessage)}`, '_blank');
    },
    shareStarted() {
      this.loading = true;
      Segment.trackUserInteraction('ReferralPopup_ShareStarted');
    },
    shareDone() {
      this.loading = false;
      Segment.trackUserInteraction('ReferralPopup_ShareDone');
    },
    shareAborted() {
      Segment.trackUserInteraction('ReferralPopup_ShareAborted');
      this.loading = false;
    },
    shareFailed(event) {
      Segment.trackUserInteraction('ReferralPopup_ShareFailed');
      DDLogs.error('Failed to share using Web Share API', { errorMessage: event.error });
    },
    async shareLink() {
      Segment.trackUserInteraction('ReferralPopup_ShareLinkClicked');
      await this.$refs.webShare.share();
    },
  },
};
</script>

<style scoped lang="scss">
  .referral-content {

    line-height: 1.5;

    .bold {
      margin-top: 15px;
      font-family: SimplerPro;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/referral/ReferralPopup.vue